<script lang="ts">
  import { Container } from "sveltestrap";
  import CountDown from "../../../Core/CountDown.svelte";
  import Link from "svelte-link";
  import { WEARECOMINGSOON } from "../../../../utils/Constant/Constant";
  let imgPath:string = "/assets/images/logo"
</script>

<div class="page-wrapper" id="pageWrapper">
  <Container fluid class="p-0">
    <div class="comingsoon">
      <div class="comingsoon-inner text-center">
        <Link href="/dashboard/default">
          <img src="{imgPath}/logo-1.png" alt="" />
        </Link>
        <h5>{WEARECOMINGSOON}</h5>
        <CountDown />
      </div>
    </div>
  </Container>
</div>
